
import React from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { ArrowUpDown } from "lucide-react";

interface SortOption {
  value: string;
  label: string;
  description?: string;
}

interface SortSelectorProps {
  selectedSort: string;
  onSortChange: (sort: string) => void;
  disabled?: boolean;
}

const sortOptions: SortOption[] = [
  { value: 'recent', label: 'Most Recent', description: 'Newest prompts first' },
  { value: 'popular', label: 'Most Popular', description: 'Based on likes, copies, and reviews' },
  { value: 'likes', label: 'Most Liked', description: 'Highest rated prompts' },
  { value: 'copies', label: 'Most Copied', description: 'Most frequently used' },
  { value: 'alphabetical', label: 'Alphabetical', description: 'A-Z by title' },
  { value: 'random', label: 'Random', description: 'Discover diverse content' },
  { value: 'relevance', label: 'Relevance', description: 'Best match for your search' },
];

const SortSelector: React.FC<SortSelectorProps> = ({
  selectedSort,
  onSortChange,
  disabled = false
}) => {
  const selectedOption = sortOptions.find(option => option.value === selectedSort);

  return (
    <div className="flex items-center gap-2">
      <ArrowUpDown className="h-4 w-4 text-muted-foreground" />
      <Select 
        value={selectedSort} 
        onValueChange={onSortChange}
        disabled={disabled}
      >
        <SelectTrigger className="w-48">
          <SelectValue placeholder="Sort by...">
            {selectedOption?.label || 'Sort by...'}
          </SelectValue>
        </SelectTrigger>
        <SelectContent>
          {sortOptions.map(option => (
            <SelectItem key={option.value} value={option.value}>
              <div>
                <div className="font-medium">{option.label}</div>
                {option.description && (
                  <div className="text-xs text-muted-foreground">{option.description}</div>
                )}
              </div>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default SortSelector;
